module.exports = __webpack_public_path__ + "static/media/homeAcademy12.7978bc35.png";